export default {
  colors: {
    text: "rgba(239,239,239,1)",
    textLight: "rgba(239,239,239,0.3)",
    backgroundColor: "#343536",
    darkerBg: "rgba(34, 35, 36,0.7)",
    nickel: "#676E6E",
  },
  spacing: [10, 12, 14],
  fontSizes: [14, 18, 26],
  text: {
    h0: { fontSize: 72, fontFamily: "Montserrat", fontWeight: "800" },
    h1: { fontSize: 30, fontFamily: "Montserrat" },
    h2: { fontSize: 22, fontFamily: "Montserrat" },
    p: { fontSize: 16, fontFamily: "Montserrat" },
  },
};
